module.exports = __webpack_public_path__ + "img/1019.f69b18af.png";